import Button from "../../components/Shared/Button";
import { useState } from "react";
import AddIcon from "../../components/Icons/AddIcon";
import AddFaq from "../../components/Dashboard/Faqs/AddFaq";
import { useQuery } from "@tanstack/react-query";
import { getFAQ } from "../../api/FAQs/GetAllFAQ";
import Spinner from "../../components/Shared/Spinner";
import FaqTable from "../../components/Dashboard/Faqs/FaqTable";
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton";
const Faqs = () => {
  const [showManageFaq, setShowManageFaq] = useState(false);
  const { data: FaqResponse, isLoading: isFaqLoading } = useQuery({
    queryFn: getFAQ,
    queryKey: ["faqs"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const faqData = FaqResponse?.data?.faqData || [];

  return (
    <div className="py-7">
      <div className="flex justify-between">
        <h1 className="text-burntBlack font-bold text-[32px] mb-7">FAQS</h1>
        <Button
          onClick={() => setShowManageFaq(true)}
          className="!h-12 w-40 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
          variant="primary"
        >
          <AddIcon className="mr-1.5" />
          Add New FAQ
        </Button>

      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15">
        {showManageFaq ? (
          <div className="space-y-4">
            <DashboardInlineBackButton
              label="Back to FAQs"
              onClick={() => setShowManageFaq(false)}
            />
            <AddFaq onSuccess={() => setShowManageFaq(false)} />
          </div>
        ) : (
          <>
            {isFaqLoading ? (
              <div className="min-h-[50vh] flex justify-center items-center">
                <Spinner />
              </div>
            ) : (

              <FaqTable data={faqData} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Faqs;
